import { render, staticRenderFns } from "./EditCategoria.vue?vue&type=template&id=652b9e1b&"
import script from "./EditCategoria.vue?vue&type=script&lang=js&"
export * from "./EditCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports